import React from "react";
import { BrandBannerImage } from "./BannerImage";
import { RichtextRenderer } from "@/components/atoms/rich-text-render";
interface IBannerBrandProps {
  brandData: IBanner;
}
export interface IBanner {
  documentId?: string;
  brandName?: string;
  description?: string;
  brandLogoUrl?: string;
  brandMobileUrl: string;
  brandDesktopUrl: string;
  alt?: string;
  caption?: string;
  itemName?: string;
  isShowFilter?: boolean | null;
}

/**
 * BannerBrand component
 * Displays a brand banner with image, gradient overlay, and rich text description for a hotel brand.
 * Used in hotel result pages to highlight brand information visually.
 */

const BannerBrand: React.FC<IBannerBrandProps> = ({ brandData }) => {
  // Render brand banner only if brandData is provided
  return (
    <>
      {brandData && (
        <div className="relative min-h-[480px] w-full md:h-full">
          <BrandBannerImage
            brandDesktopUrl={brandData?.brandDesktopUrl}
            brandMobileUrl={brandData?.brandMobileUrl}
            alt={brandData.alt || ""}
            caption={brandData.caption || ""}
          />
          <div className="absolute inset-0 z-2 bg-linear-to-t from-black/80 via-black/30 to-transparent"></div>
          <div className="absolute top-1/2 left-0 z-3 -translate-y-1/2 transform p-4 text-white md:w-full md:py-16 lg:left-8 lg:w-full lg:px-30 xl:w-4/5 2xl:w-13/20">
            <div className="flex flex-col items-start gap-4">
              {brandData?.brandName && (
                <h1 className="text-2xl md:text-[50px] lg:text-[65px] 2xl:text-[82px]">
                  {brandData?.brandName}
                </h1>
              )}
            </div>
            {brandData?.description && (
              <RichtextRenderer
                className="mt-2 text-lg text-white! md:mt-4 md:text-base"
                content={brandData?.description}
              />
            )}
          </div>
        </div>
      )}
    </>
  );
};

export { BannerBrand };
